module.exports = __webpack_public_path__ + "img/sprite-1.fb6ca883.webp";